module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Acknowledgement"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01"
    }
  }, [_c('b', [_vm._v("1. Organology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_1"
    }
  }, [_vm._v("I. Historical Background")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_2"
    }
  }, [_vm._v("II. The Pedal Harp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_3"
    }
  }, [_c('i', [_vm._v("General Characteristics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_4"
    }
  }, [_c('i', [_vm._v("The Parts of the Harp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_5"
    }
  }, [_c('i', [_vm._v("The Strings")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_6"
    }
  }, [_c('i', [_vm._v("The Pedals and the Modulation Mechanism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_7"
    }
  }, [_c('i', [_vm._v("Using the Pedals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_8"
    }
  }, [_c('i', [_vm._v("Pedal Notation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_9"
    }
  }, [_c('i', [_vm._v("Playing the Harp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_10"
    }
  }, [_vm._v("III. The Lever Harp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_11"
    }
  }, [_c('i', [_vm._v("General Characteristics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_12"
    }
  }, [_c('i', [_vm._v("The Strings")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_13"
    }
  }, [_c('i', [_vm._v("Levers and the Modulation Mechanism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_14"
    }
  }, [_c('i', [_vm._v("Playing the Lever Harp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_15"
    }
  }, [_vm._v("IV. Electric Harps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_16"
    }
  }, [_c('i', [_vm._v("The Electroacoustic Harp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_17"
    }
  }, [_c('i', [_vm._v("The Electric Harp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_18"
    }
  }, [_c('i', [_vm._v("The Electric-Acoustic Harp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_19"
    }
  }, [_vm._v("V. Some Twenty-First-Century Creations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_20"
    }
  }, [_c('i', [_vm._v("The MIDI Harp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2b"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1_21"
    }
  }, [_c('i', [_vm._v("The Automatic Harp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2. Writing and Language")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Notation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Measured Notation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Unmeasured Notation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Proportional Notation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Introduction of the Aleatory Element (Indeterminacy)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Open Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Combination of Several Notations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Superposition of Different Tempi")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Writing on Several Staves")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Writing with a System Other than the Five-Line Stave")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Graphic Scores")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Dramatized Writings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Microchoreography, Theatrical Gestures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Dramaturgic Use of the Voice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Use of the Sung Voice, with No Theatrical Indication")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Use of the Spoken and the Sung Voice with No Text")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Mixed Forms of Music")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Some Works for Harp and Extensions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3. Playing Techniques")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Timbre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Près de la table (Near the Soundboard)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bas dans les cordes (Low in the Strings)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Près des chevilles (Near the Tuning Pins)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Harmonic Sound")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Sound Using the Fingernail")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Koto Sound")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Plucked Sound")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Vibrated Sound")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Portando from One Pitch to Another")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Xylo Sound")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Pizzicato (Pizz.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bartók Pizzicato")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Normal Position")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bisbigliando")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Tone-Color Melody (Klangfarbenmelodie)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Glissandi, Chords, and Clusters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Single Glissando")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_19",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Fast Glissando")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Multiple Glissando")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_21",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Pitchless Glissandi")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_22",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Flat, Broken, Arpeggiated/Rolled Chords")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Cluster Glissando")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_24",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Rasgueado")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_25",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Cluster Glissando with Thunder Effect")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_26",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Cluster")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_27",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Muffled Cluster")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_28",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Tremolo Cluster")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_29",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Aeolian Cluster")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_30",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Various Forms of Rubbing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Resonances, Muffles, and Silences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_32",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Muffles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_33",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Let Vibrate")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_34",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Fermata")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. Hits on the Harp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_36",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Different Types of Hits")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_37",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Which Part of the Harp to Hit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_38",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Composers Who Have Elaborated a Detailed Notation for Hits")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. Wire Strings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_40",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Whistling Sound (With the Palm of the Hand)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_41",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Wired Sound (Grabbing a Wire String with the Fingers)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_42",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Scrape with a Nail or a Plectrum")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_43",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Buzz")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_44",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Thunder Effect")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_45",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Sustained Thunder Effect")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. Pedals and Levers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_47",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Pedal Glissando")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_48",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Pedal Trill")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_49",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Rhythmic Effect with Pedals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_50",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Pedal Movement Ad Libitum with Sound Effect")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_51",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Pedal Buzz")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_52",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Resonant Pedal Sound")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_53",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Levers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_54",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Thunder Effect")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. Using Objects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_56",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Metal Rod")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_57",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Stick")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_58",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Specific Effects Obtained with a Superball")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_59",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Use of Percussion Instruments by the Harpist")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_60",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_61",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Electronic Bow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_62",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Plectrum")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_63",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Other Objects")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_64",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Prepared Harp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_65",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Inserting Materials between the Strings")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. Scordatura")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_67",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Pedal Harp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_68",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Lever Harp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3_69",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Two Harps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Timeline of the Harp, 1900–Present")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("List of Notations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Bibliography#bib_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The History of Music in the Twentieth and Twenty-First Centuries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Bibliography#bib_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Contemporary Notation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Bibliography#bib_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Musical Instruments: The Orchestra")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Bibliography#bib_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Harp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Bibliography#bib_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Websites")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Bm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Repertoire of Works for Harp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Bm03#bm3_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Solo Harp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Bm03#bm3_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Harp and Extensions Lever Harp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Bm03#bm3_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Lever Harp and Extensions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Bm03#bm3_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Duets and Harp Ensembles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Bm03#bm3_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Concertos")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Bm03#bm3_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Duets")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Bm03#bm3_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Trios")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Bm03#bm3_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Quartets and More")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Bm03#bm3_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Ensembles and Extensions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Index01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Composers Quoted")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Index02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Playing Techniques")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06ac474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 69
// module chunks = 0